import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useThemeStore } from '@/stores/themeStore';
import { FiSun, FiMoon, FiMenu, FiX } from 'react-icons/fi';
import { motion, AnimatePresence } from 'framer-motion';

const navLinks = [
  { path: "/learn", label: "Учиться" },
  { path: "/", label: "Демонстрации" },
  { path: "/glossary", label: "Глоссарий" },
  { path: "/about", label: "О проекте" },
  { path: "/resources", label: "Ресурсы" },
  { path: "/yuv", label: "YUV" },
];

export const Navbar: React.FC = () => {
  const { theme, toggleTheme } = useThemeStore();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const navLinkStyles = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-full text-sm font-semibold transition-colors ${
      isActive
        ? 'bg-secondary/20 text-primary'
        : 'text-text-secondary hover:text-text-primary hover:bg-black/5 dark:hover:bg-white/5'
    }`;
  
  const mobileNavLinkStyles = ({ isActive }: { isActive: boolean }) =>
    `block px-4 py-3 text-base font-semibold transition-colors ${
      isActive ? 'text-primary' : 'text-text-primary'
    }`;

  return (
    <nav className="bg-bg-card/80 backdrop-blur-md shadow-sm sticky top-0 z-50">
      <div className="max-w-6xl mx-auto px-4">
        <div className="flex justify-between items-center h-16">
          <NavLink to="/" className="flex items-center space-x-3">
            <div className="w-9 h-9 bg-primary rounded-lg flex items-center justify-center shadow-md">
              <span className="text-white font-bold text-base">ТЭС</span>
            </div>
            <span className="text-xl font-bold text-text-primary">Визуализатор</span>
          </NavLink>

          <div className="flex items-center space-x-2">
            {/* Десктопная навигация */}
            <div className="hidden md:flex items-center space-x-2">
              {navLinks.map(link => (
                <NavLink key={link.path} to={link.path} className={navLinkStyles}>{link.label}</NavLink>
              ))}
            </div>
            
            <button
              onClick={toggleTheme}
              className="w-10 h-10 rounded-full flex items-center justify-center text-text-secondary hover:text-text-primary hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
              aria-label="Переключить тему"
            >
              {theme === 'light' ? <FiMoon /> : <FiSun />}
            </button>

            <div className="md:hidden">
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="w-10 h-10 rounded-full flex items-center justify-center text-text-secondary hover:text-text-primary hover:bg-black/5 dark:hover:bg-white/5 transition-colors"
                aria-label="Открыть меню"
              >
                {isMenuOpen ? <FiX /> : <FiMenu />}
              </button>
            </div>
          </div>
        </div>
      </div>

      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.2 }}
            className="md:hidden bg-bg-card shadow-lg"
          >
            <div className="px-2 pt-2 pb-3 space-y-1">
              {navLinks.map(link => (
                <NavLink 
                  key={link.path} 
                  to={link.path} 
                  className={mobileNavLinkStyles}
                  onClick={() => setIsMenuOpen(false)} 
                >
                  {link.label}
                </NavLink>
              ))}
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};